import { Component, inject, Inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';
import { MatCardModule } from '@angular/material/card';
@Component({
  selector: 'lib-web-shared-ui-lib-view-img-popup',
  imports: [MatDialogModule, MatButtonModule, MatCardModule],
  templateUrl: './lib-view-img-popup.component.html',
  styleUrl: './lib-view-img-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibViewImgPopupComponent {
  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string },
    private dialogRef: MatDialogRef<LibViewImgPopupComponent>
  ) {
    // data.url = this.findVideoId(data.url);
    this.urlImg.set(data.url);
    this.loggingService.warn('urlImg', this.urlImg());
  }

  urlImg = signal<string>('');
  // findVideoId(url: string) {
  //   return url.split('/')[3].split('?')[0];
  // }
  closeDialog(productId: string) {
    this.dialogRef.close(productId);
  }
}
